import { render, staticRenderFns } from "./Interact.vue?vue&type=template&id=147c046c&scoped=true&"
import script from "./Interact.vue?vue&type=script&lang=js&"
export * from "./Interact.vue?vue&type=script&lang=js&"
import style0 from "./Interact.vue?vue&type=style&index=0&id=147c046c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147c046c",
  null
  
)

export default component.exports